"use client";

import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { Primitive } from "@radix-ui/react-primitive";
import { type ElementRef, forwardRef, ComponentPropsWithoutRef } from "react";
import {
  UseThreadViewportAutoScrollProps,
  useThreadViewportAutoScroll,
} from "../../primitive-hooks/thread/useThreadViewportAutoScroll";

/**
 * @deprecated Use `ThreadPrimitive.Viewport.Props` instead. This will be removed in 0.6.
 */
export type ThreadPrimitiveViewportProps = ThreadPrimitiveViewport.Props;

export namespace ThreadPrimitiveViewport {
  export type Element = ElementRef<typeof Primitive.div>;
  export type Props = ComponentPropsWithoutRef<typeof Primitive.div> &
    UseThreadViewportAutoScrollProps;
}

export const ThreadPrimitiveViewport = forwardRef<
  ThreadPrimitiveViewport.Element,
  ThreadPrimitiveViewport.Props
>(({ autoScroll, children, ...rest }, forwardedRef) => {
  const autoScrollRef = useThreadViewportAutoScroll<HTMLDivElement>({
    autoScroll,
  });

  const ref = useComposedRefs(forwardedRef, autoScrollRef);

  return (
    <Primitive.div {...rest} ref={ref}>
      {children}
    </Primitive.div>
  );
});

ThreadPrimitiveViewport.displayName = "ThreadPrimitive.Viewport";
